import { CUSTOM_TABLES_INDEXER_NOTIFICATION_PREFIX } from '../constants/custom-tables';
import { useNotificationsStore } from '../stores/notificationsStore';
import { type BackendNotification, type NotificationAction, NotificationActionType } from '../types/notifications';

export default defineNuxtPlugin(() => {
    const { addHandler, addNotificationComponent } = useNotificationsStore();
    const { $i18n } = useNuxtApp();
    const t = $i18n.t.bind($i18n);

    const parsedKeysAndData = (notification: BackendNotification) => {
        const parsedData: Record<string, unknown> = JSON.parse(notification.data as unknown as string);
        const parsedKeys: Record<string, string> = JSON.parse(notification.keys as unknown as string);
        return { parsedData, parsedKeys };
    };

    addNotificationComponent(
        'CustomTableIndexerNotification',
        defineAsyncComponent(() => import('../components/CustomTableIndexerNotification.vue'))
    );

    addHandler(CUSTOM_TABLES_INDEXER_NOTIFICATION_PREFIX, (notification: BackendNotification): (NotificationAction | undefined) => {
        const { parsedData } = parsedKeysAndData(notification);

        return {
            actionType: NotificationActionType.ADD_NOTIFICATION,
            payload: {
                notification: {
                    eventName: notification.eventName,
                    timestamp: notification.time,
                    keys: { tableName: notification.resourceId ?? '' },
                    data: parsedData,
                    componentName: 'CustomTableIndexerNotification',
                    failed: true,
                    header: 'notifications.customTables.header'
                }
            }
        };
    });

    addHandler(CUSTOM_TABLES_INDEXER_NOTIFICATION_PREFIX, (notification: BackendNotification): (NotificationAction | undefined) => {
        const tableName = notification.resourceId ?? '';
        const { parsedKeys, parsedData } = parsedKeysAndData(notification);
        const extractedKeys = (parsedKeys?.sk?.split('#').slice(1) ?? []).join(', ');
        const reason = (parsedData?.reason as string) ?? '';

        const detail = reason
            ? t('notifications.customTables.toastDetailWithReason', { tableName, keys: extractedKeys, reason })
            : t('notifications.customTables.toastDetail', { tableName, keys: extractedKeys });

        return {
            actionType: NotificationActionType.SHOW_TOAST,
            payload: {
                detail,
                summary: t('notifications.customTables.toastSummary'),
                severity: 'error'
            }
        };
    });
});
